import { EXAMS_ENDPOINT, URl_TOKEN } from "../http/base-urls"
import  http from '../http'

export async function generateUrlToken(dicom){
    try{
        const response = await http.post(URl_TOKEN, {Dicom : dicom})
        return response.data;
    }catch(Erro){
        throw new Error();
    }
}

export async function getExams(servideIndentifierNumber, password){
    const examsEndpoint = EXAMS_ENDPOINT
    .replace("{protocolo}", servideIndentifierNumber)
    .replace("{senha}", password);
    try{
        const response = await http.get(examsEndpoint);
        return response.data;
    }catch(error){        
        throw new Error();
    }
}